<template>
    <div id="posta-cell-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('whatsappChannel.postaCellDetail') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>
        <div class="wrapper">
            <div class="toolbar">
                <div class="left">
                    <IconButton :on-click="() => $router.push('/integrations/sms/postacell')">
                        <span class="material-icons"> chevron_left </span>
                    </IconButton>
                    <div class="icon-container">
                        <img src="/static/img/postacell-logo.png" />
                    </div>
                    <div class="name">PostaCell</div>
                </div>
            </div>
            <div class="channel-content">
                <div class="left">
                    <ChannelMenu v-model="currentTab" />
                </div>
                <div class="page-content" v-if="channel">
                    <div v-if="currentTab === PostaCellChannelMenuTypes.CHANNEL.id">
                        <UpdateDetail v-model="channel" :credit="credit" />
                    </div>
                    <div v-if="currentTab === PostaCellChannelMenuTypes.BROADCAST_REQUESTS.id">
                        <SendSmsPostacell v-model="channel" :senders="senders" :credit="credit" />
                    </div>
                    <div v-if="currentTab === PostaCellChannelMenuTypes.BROADCAST.id">
                        <BulkSmsPostacell v-model="channel" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppBreadCrumb from "../../../../../../components/common/AppBreadCrumb.vue";
import WhatsappBusinessIcon from "../../../../Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import IconButton from "../../../../Settings/components/IconButton.vue";
import PostaCellChannelMenuTypes from "./PostaCellChannelMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import SendSmsPostacell from "./SendSmsPostacell.vue";
import BulkSmsPostacell from "./BulkSmsPostacell.vue";
import { mapActions, mapState } from "vuex";
import ChannelMenu from "./ChannelMenu.vue";
import _ from "lodash";

export default {
    name: "PostaCellChannelDetail",
    components: {
        ChannelMenu,
        IconButton,
        WhatsappBusinessIcon,
        AppBreadCrumb,
        UpdateDetail,
        SendSmsPostacell,
        BulkSmsPostacell,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(PostaCellChannelMenuTypes).find((x) => x.path === path);
        return {
            currentTab: selected ? selected.id : "detail",
            PostaCellChannelMenuTypes,
            channel: null,
            selectedChannelId: this.$route.params.id,
            senders: [],
            credit: 0,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            getPostacellChannelSenders: "channel/getPostacellChannelSenders",
            getPostacellChannelCredit: "channel/getPostacellChannelCredit",
        }),
    },
    mounted() {
        this.getPostacellChannelSenders(this.selectedChannelId).then((data) => {
            this.senders = _.get(data, "list", []);
        });
        this.getPostacellChannelCredit(this.selectedChannelId).then((data) => {
            this.credit = data;
        });
        this.listChannels().then((channels) => {
            this.channel = channels.find((x) => x._id === this.selectedChannelId);
            this.originalChannel = _.cloneDeep(this.channel);
        });
    },
    watch: {
        currentTab(value) {
            const selected = Object.values(PostaCellChannelMenuTypes).find((x) => x.id === value);
            if (selected) {
                this.$router.push(`/integrations/sms/postacell/${this.$route.params.id}/detail/${selected.path}`);
            }
        },
    },
};
</script>
<style scoped lang="scss">
#posta-cell-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;

        .toolbar {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 50px;
            border: 1px solid var(--color-border-default);

            .left {
                display: flex;
                align-items: center;
                gap: 5px;

                .name {
                    font-size: 18px;
                    font-weight: 700;
                }

                .icon-container {
                    width: 100px;
                    height: 30px;
                    display: flex;
                    margin: 0 auto;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;
                    position: relative;
                    padding: 10px;
                }
            }

            .right {
                display: flex;
                justify-content: flex-end;
                gap: 5px;
            }
        }

        .channel-content {
            display: flex;
            height: 100%;

            .left {
                width: 275px;
                height: 100%;

                .channel-menu {
                    width: 100%;
                }
            }

            .page-content {
                width: calc(100% - 275px);
                height: 100%;
            }
        }
    }
}
</style>
